import { FormattedMessage } from '@alltrails/shared/react-intl';
import useMobileWidth from 'hooks/useMobileWidth';
import * as styles from './styles/styles.module.scss';
import NatureUnitesCollage from './NatureUnitesCollage';

const NatureUnites = (): JSX.Element => {
  const isMobileView = useMobileWidth();
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FormattedMessage
          defaultMessage="We believe nature is what <span>unites us all</span>"
          values={{ span: (chunks: string) => <span className={styles.greenHeader}>{chunks}</span> }}
        />
      </div>
      <div className={styles.subHeader}>
        <FormattedMessage
          defaultMessage="<span>Our mission is simple:</span> {br}To kindle the spirit of adventure"
          values={{
            span: (chunks: string) => <span className={styles.boldSubHeader}>{chunks}</span>,
            br: isMobileView ? <br /> : null
          }}
        />
      </div>
      <NatureUnitesCollage />
    </div>
  );
};

export default NatureUnites;
